import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, InputGroup, InputGroupText } from 'reactstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Formik, Field, ErrorMessage } from 'formik';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword } from '../../slices/veloxity/auth/ChangePasswordReducer';
import { showLoadingAlert, showSuccessAlert, showErrorAlert } from '../custom/sweetalertHelper'
const ChangePasswordModal = ({ isOpen, toggle }) => {
    const dispatch = useDispatch();
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { loading, success, error } = useSelector(state => state.changePassword);
    useEffect(() => {
        if (loading) {
            showLoadingAlert('Changing Password', 'Please wait while we change your password...');
        } else {
            Swal.close();
            if (success) {
                showSuccessAlert('Password Changed', 'Your password has been changed successfully.');
            } else if (error) {
                showErrorAlert('Error', error);
            }
        }
    }, [loading, success, error]);
    const validationSchema = Yup.object({
        currentPassword: Yup.string().required('Current password is required'),
        newPassword: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .max(25, 'Password must be less than 25 characters')
            .matches(/.*[a-z].*/, 'Password must contain at least one lowercase letter')
            .matches(/.*[A-Z].*/, 'Password must contain at least one uppercase letter')
            .matches(/.*\d.*/, 'Password must contain at least one digit')
            .matches(/.*[!@#$%^&*(),.?":{}|<>].*/, 'Password must contain at least one special character')
            .required('New password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Both passwords need to be the same')
            .required('Confirm password is required'),
    });
    const handlePasswordChange = (values) => {
        dispatch(changePassword(values));
    };
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered={true}>
            <ModalBody>
                <Formik
                    initialValues={{
                        currentPassword: '',
                        newPassword: '',
                        confirmPassword: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        handlePasswordChange(values);
                        toggle()
                    }}
                >
                    {({ handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                            <FormGroup>
                                <Label for="currentPassword">Current Password</Label>
                                <InputGroup>
                                    <Field
                                        name="currentPassword"
                                        type={showCurrentPassword ? 'text' : 'password'}
                                        as={Input}
                                    />
                                    <InputGroupText onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                                        {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroupText>
                                </InputGroup>
                                <ErrorMessage name="currentPassword" component="div" className="text-danger" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="newPassword">New Password</Label>
                                <InputGroup>
                                    <Field
                                        name="newPassword"
                                        type={showNewPassword ? 'text' : 'password'}
                                        as={Input}
                                    />
                                    <InputGroupText onClick={() => setShowNewPassword(!showNewPassword)}>
                                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroupText>
                                </InputGroup>
                                <ErrorMessage name="newPassword" component="div" className="text-danger" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="confirmPassword">Confirm New Password</Label>
                                <InputGroup>
                                    <Field
                                        name="confirmPassword"
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        as={Input}
                                    />
                                    <InputGroupText onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroupText>
                                </InputGroup>
                                <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                            </FormGroup>
                            <ModalFooter>
                                <Button color="secondary" onClick={toggle}>Cancel</Button>
                                <Button color="primary" type="submit" disabled={loading}>
                                    {loading ? 'Changing...' : 'Change Password'}
                                </Button>
                            </ModalFooter>
                        </Form>
                    )}
                </Formik>
            </ModalBody>
        </Modal>
    );
};
export default ChangePasswordModal;